import { render, staticRenderFns } from "./CustomerCommunicationNewModal.vue?vue&type=template&id=623d0578&scoped=true&lang=pug&"
import script from "./CustomerCommunicationNewModal.vue?vue&type=script&lang=js&"
export * from "./CustomerCommunicationNewModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCommunicationNewModal.vue?vue&type=style&index=0&id=623d0578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d0578",
  null
  
)

/* custom blocks */
import block0 from "./CustomerCommunicationNewModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports